import { AuthService } from "./services/AuthService";

const apiUrl = process.env.REACT_APP_API_URL;
export const authService = new AuthService({
  baseUrl: apiUrl,
});

// TODO: Можно вынести и в верхний DI, но тут он тоже нужен, обсудим
